import { Cookies } from '@/libs/cookies/index'
import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'
import { PopUps } from '@/utilities/popups'
import Promise from 'promise-polyfill'
// const baseSelector: string = '[data-selector="sessionsFormWrapper"]'

export class UsersSessions {

  private base: JQuery | null = null

  private readonly selectors: ISelectors = {
    form: '[data-selector="loginPopupsForm"]',
    logoutBtn: '[data-selector="userBtnOut"]',
    wrapform: '[data-selector="loginPopupsWrapper"]',
    // base: baseSelector,
  }

  constructor() {
    this.base = $('body')
    this.init()
  }

  // Инициализация "компонента"
  public init(): void {
    this.initValidationRules()

    $('body')
      .on('click', this.selectors.logoutBtn, (e) => this.handlerLogout())
  }

  // Наложить на форму правила валидации
  private initValidationRules(): void {
    this.base.find(this.selectors.form).validate()
  }

  // Разлогин пользователя по новому апи
  private handlerLogout(): void {
    const url = '/api/v2/crm/admin_users/sign_out/'

    const token = Cookies.get('token')

    $.ajax({
      error: (xhr) => {
        window.location.reload()
      },
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      processData: false,
      success: () => {
        window.location.href = '/'
      },
      type: 'DELETE',
      url,
    })
  }
}
